import Guide from "../../components/Guide";
function GuidePage() {
  return (
    <div>
      <Guide />
    </div>
  );
}

export default GuidePage;
